export const REGEX_SPECIAL_CHARS = /[.*+?^${}()|[\]\\]/g;

/**
 * Escapes regex special characters in text
 */
const escapeRegexCharacters = (text: string): string => {
  return text.replace(REGEX_SPECIAL_CHARS, '\\$&');
};

/**
 * Creates a regex pattern for text matching, applying word boundaries
 * unless the text contains parentheses (like "(No Value)")
 */
const createTextMatchPattern = (text: string): string => {
  const escaped = escapeRegexCharacters(text);
  // For "(No Value)" and similar patterns with parentheses, use exact match instead of word boundaries
  if (text.includes('(') && text.includes(')')) {
    return escaped;
  }
  return `\\b${escaped}\\b`;
};

/**
 * Creates a RegExp object for text matching
 */
export const createTextMatchRegex = (text: string): RegExp => {
  const pattern = createTextMatchPattern(text);
  return new RegExp(pattern);
};

/**
 * Creates a combined regex pattern for multiple texts
 *
 * The output regex uses a capturing group with alternation (pattern1|pattern2|...)
 * to match any of the provided texts. Each text is escaped and wrapped with word
 * boundaries (\b) for exact word matching, unless it contains parentheses.
 *
 * Example output: "(\bword1\b|\bword2\b|exact_match_with_parentheses)"
 * This allows matching any of the specified texts as complete words or exact strings.
 */
export const createCombinedRegexPattern = (texts: string[]): string => {
  if (texts.length === 0) {
    return '(?!.*)'; // Matches nothing
  }

  const escapedTexts = texts.map(createTextMatchPattern);
  return `(${escapedTexts.join('|')})`;
};
